import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { NavigationEnd, Router, RouterLink } from '@angular/router';

import { TranslocoPipe } from '@jsverse/transloco';

import { AppInfoService } from '@app/core/services/app-info.service';
import { LocalStorageService } from '@app/core/services/local-storage.service';
import { OktaService } from '@app/core/services/okta.service';
import { ProfileService } from '@app/core/services/profile.service';
import { AppEnvironment } from '@models/app-info.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, MatIcon, AsyncPipe, RouterLink, MatSuffix],
  host: {
    id: 'ac78c3f8-14f6-4349-8f41-c7d3cf7e87e7',
  },
})
export class FooterComponent {
  oktaService = inject(OktaService);
  profileService = inject(ProfileService);
  router = inject(Router);
  localStorageService = inject(LocalStorageService);
  appInfoService = inject(AppInfoService);
  data$: Observable<{ isLoggedIn: boolean; showFooter: boolean; isAdmin: boolean; isAllowed: boolean }> = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map((event: NavigationEnd) => event.urlAfterRedirects),
    map((currentUrl: string) => ({
      isLoggedIn: this.oktaService.hasValidAccessToken(),
      isAllowed: this.appInfoService.appInfo.isAllowedEnvironment([AppEnvironment.dvp, AppEnvironment.local]),
      isAdmin: this.profileService.getUser()?.isEngie,
      showFooter: !(
        this.oktaService.hasValidAccessToken() &&
        !this.profileService.isTermsOfUseCompliant() &&
        currentUrl.includes('terms-of-use')
      ),
    })),
  );
  closeCookiesPolicyWarning = this.localStorageService.closeCookiesWarning;

  closePolicy() {
    this.closeCookiesPolicyWarning = true;
    this.localStorageService.closeCookiesWarning = this.closeCookiesPolicyWarning;
  }
}
